module.exports = __webpack_public_path__ + "img/03.e0ec3197.jpg";